import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
	login: {
		Welcome: '欢迎',
		correct: '请输入正确的电子邮件地址',
		enter: '请输入密码',
		Sign: '登录',
		Forgot: '忘记密码',
		Create: '创建账户',
		Password: '请输入您的密码',
		Welcome_to_TOZO: '欢迎来到TOZO',
		email: '请输入电子邮件地址',
		agree: ' * 我同意',
		Agreement: '用户协议',
		see: '。请参阅我们的',
		Policy: '隐私政策',
		here: '这里。',
		Account: '创建账户',
		account: '或使用您的社交账户继续',
		email_placeholder: '请输入您的账号或电子邮件',
		email_required: '请输入您的账号或电子邮件',
		email_correct: '请填写正确的电子邮件地址',
		password_required: '请填写密码',
		login_fail: '登录失败',
		error_4000: '应用程序名称不能为空或链接不存在',
		error_4006: '对不起，您输入的验证码不正确',
		error_4008: '对不起，电子邮件地址已被注册',
		error_4009: '对不起，您输入的账户不存在',
		error_4010: '对不起，您输入的账户密码不正确',
	},
	register: {
		register_title: '注册账户',
		email_placeholder: '请输入您的电子邮件',
		code_placeholder: '请输入验证码',
		get: '获取',
		countdownTips: '验证码有效期为十分钟',
		password_placeholder: '请输入密码',
		confirm_password_placeholder: '请再次输入密码',
		regulation: '密码必须包含8-16个字符，并且至少由以下两种组合而成：数字、字母或符号。',
		agree_text1: '我已阅读并同意',
		agree_text2: '账户使用协议、账户隐私声明',
		register_btn: '注册',
		agree_required: '需要勾选同意',
		password_required: '请确认密码',
		confirmed_and_password_correct: '确认密码与第一次输入的密码不一致',
		email_required: '请输入电子邮件账户',
		email_correct: '电子邮件格式错误',
		code_required: '请输入验证码',
		password_required_js: '请输入密码',
		password_correct: '密码长度应在8到16个字符之间',
		registered: '该邮箱已被注册',
		email_format: '电子邮件地址格式不正确',
		account_required: '账户是必需的',
		email_information: '验证码已成功发送，请注意查收邮件',
		register_successfully: 'TOZO账户已成功注册',
	},
	reset: {
		reset_title: '重置密码',
		old_password_placeholder: '请输入您的旧密码',
		new_password_placeholder: '请输入您的新密码',
		password_confirmation: '请再次输入您的新密码',
		reset_btn: '重置',
		reconfirm_new_password: '请重新确认新密码',
		new_password_verify: '两次输入的新密码不一致',
		password_format: '密码长度应在8到16个字符之间',
		password_changed_successfully: '密码修改成功',
	},
	forgot: {
		forgot_title: '找回您的密码',
		email_placeholder: '请输入您的电子邮件',
		code_placeholder: '请输入验证码',
		get: '获取',
		countdownTips: '验证码有效期为十分钟',
		password_placeholder: '请输入新密码',
		confirm_password_placeholder: '请再次输入新密码',
		submit_btn: '提交',
		password_required: '请确认新密码',
		confirmed_and_password_correct: '确认密码与第一次输入的密码不一致',
		email_required: '请输入电子邮件账户',
		email_correct: '请输入正确的电子邮件格式',
		code_required: '请输入验证码',
		password_required_js: '请输入新密码',
		password_correct: '密码长度应在8到16个字符之间',
		email_information: '验证码已成功发送，请注意查收邮件',
		email_verify: '请输入您的电子邮件',
		forgot_successfully: '密码修改成功',
	},
	page_404: {
		SORRY: "抱歉！",
		reserved: "版权所有",
		check_text: "请检查您输入的URL是否正确，或点击下方按钮返回主页。",
		Back_Home: "返回首页",
		Get_Support: "获取支持",
		message: "抱歉，您无法访问此页面..."
	},
	nav_box: {
		title: {
			NEW_RELEASES: '新品发布',
			HEADPHONES: '耳机',
			WATCHES: '手表',
			SPEAKERS: '音箱',
			HOT_SALE: '热卖',
			MID_YEAR_SALE: "年中大促",
			GAME_DEALS: "游戏特惠",
			HALLOWEEN_SALE: "万圣节特惠",
			BLACK_FRIDAY: '黑色星期五',
			CYBER_MONDAY: '网络星期一',
			DEALS: '特惠',
			CHRISTMAS_SALE: '圣诞促销',
			TOZO_COUPON: 'TOZO优惠券',
			HOLIDAY_SALE: '节日促销',
			SOUND_DEALS: "声音交易",
			VALENTINE_S_DAY: "情人节",
			ST_PATRICK_S_DAY: "圣帕特里克节",
			SPRING_SALE: "春季促销",
			EASTER_SALE: "复活节特卖",
			EARTH_DAY_SALE: "世界地球日特卖",
			MOTHERS_DAY_SALE: "母亲节特惠",
			FATHERS_DAY: "父亲节",
			INDEPENDENCE_DAY: "独立日",
			PRIME_DAY: "PRIME会员日",
			SUMMER_SALE: "夏季促销",
			BACK_TO_SCHOOL: "开学季",
			NEW_YEAR_SALE: "新年促销",
			SUMMER_DEALS: "夏日特惠",
			SUPPORT: '支持',
			EXPLORE: '探索',
		},
		NEW_RELEASES: {
			Shop_All_New_Releases: '购买所有新品',
		},
		HEADPHONES: {
			EARBUDS: '耳塞',
			OPEN_EAR: '开放式耳机',
			OVER_EAR: '头戴式耳机',
			Active_Noise_Cancelling: '主动降噪',
			Fitness: "健身",
			Wireless_Charging: '无线充电',
			Hi_Res_Audio: '高解析音频',
			Premium_Call_Quality: '高级通话质量',
			Gaming: '游戏',
			Waterproof_Earbuds: "防水耳机",
			Translate_Earbuds: "翻译耳机",
			Shop_All_Headphones: '购买所有耳机',
			FILTERING: '筛选',
		},
		WATCHES: {
			Shop_All_Watches: '购买所有手表',
		},
		SPEAKERS: {
			Shop_All_Speakers: '购买所有音箱',
		},
		SUPPORT: {
			SERVICES: '服务',
			Support_Center: '支持中心',
			Process_Warranty: '处理保修',
			Order_Tracker: '订单跟踪',
			Privacy_Center: '隐私中心',
			Contact_Us: '联系我们',
			FAQs: '常见问题',
			Support_Videos: '支持视频',
			Manuals: '手册',
			Warranty_Info: '保修信息',
		},
		EXPLORE: {
			ACTIVITIES: '活动',
			CES_2026: "CES 2026",
			CES_2025: "CES 2025",
			CES_2024: 'CES 2024',
			NC20_Available: "NC20 可用",
			NC20_Pro_Coming: "NC20 Pro 即將上市",
			TOZO_Coupon: 'TOZO优惠券',
			BLACK_FRIDAY: '黑色星期五',
			CYBER_MONDAY: '网络星期一',
			CHRISTMAS_SALE: '圣诞促销',
			HOLIDAY_SALE: '节日促销',
			SOUND_DEALS: "声音交易",
			VALENTINE_S_DAY: "情人节",
			PROMOTION: '促销',
			HOT_SALE: '热卖',
			Halloween_Sale: "万圣节特惠",
			TOZOAiryEar: 'TOZO AiryEar',
			ST_PATRICK_S_DAY: "圣帕特里克节",
			SPRING_SALE: "春季促销",
			EASTER_SALE: "复活节特卖",
			HT3_Coming_Soon: "HT3 即将推出",
			EARTH_DAY_SALE: "世界地球日特卖",
			MOTHERS_DAY_SALE: "母亲节特惠",
			FATHERS_DAY: "父亲节",
			INDEPENDENCE_DAY: "独立日",
			PRIME_DAY: "PRIME会员日",
			SUMMER_SALE: "夏季促销",
			Back_To_School: "开学季",
			CLUB: '俱乐部',
			Blog: '博客',
			Forum: "论坛",
			BRAND: '品牌',
			Our_Story: '我们的故事',
			Technology: '技术',
			TOZO_FOR_BUSINESS: "TOZO 商务",
			Dealer_Store: "经销商商店",
			TOZO_Distrbutor_Portal: "TOZO 分销商门户",
			Become_a_Distribution_Partner: "成为分销合作伙伴"
		},
		Account: {
			SIGN_IN: '登录',
			My_account: '我的账户',
			Sign_out: '退出登录',
		},
	},
	homePage: {
		banner: {
			Welcome: '欢迎来到TOZO社区'
		},
		nav: {
			Home: '主页',
			Followers_list: '关注列表',
			Fans_list: '粉丝列表',
			Personal: '个人',
			Messages: '消息'
		}
	},
	postsArr: {
		Recommand: '推荐',
		Following: '关注',
		Say_something: '说点什么？',
		Submit: '提交',
		Follow: '关注',
		Not_interested: '不感兴趣',
		Don_t_like_the_author: '不喜欢这个作者',
		Report: '举报',
		Cancel: '取消',
		Pin: '置顶',
		Unpin: '取消置顶',
		Delete: '删除',
		Cancel: '取消'
	},
	FollowersArr: {
		Followers: '关注',
		Search_for_followers: '搜索关注者'
	},
	FansArr: {
		Fans: '粉丝',
		Search_for_fans: '搜索粉丝'
	},
	PersonalArr: {
		Likes: '点赞',
		Followers: '关注',
		Fans: '粉丝',
		Posts: '帖子',
		Media: '媒体',
		Edit: '编辑'
	},
	MessagesArr: {
		Comment: '评论',
		Likes: '点赞',
		New_Fans: '新粉丝',
		Comment_you: '评论了你',
		Liked_your_comment: '点赞了你的评论',
		Liked_your_post: '点赞了你的帖子',
		Followed_you: '关注了你',
		Comment_title: '评论',
		Reply_title: '回复',
		Reply: '回复',
		View: '查看',
		Replies_title: '回复',
		replies: '回复'
	},
	CommentList: {
		Heat: '热度',
		Time: '时间',
		Reply: '回复',
		Delete: '删除',
		Copy: '复制',
		Cancel: '取消'
	},
	SearchUserArr: {
		more_users: '请输入昵称',
		Who_to_follow: '推荐关注'
	},
	postreportArr: {
		page_title: '举报',
		report_title: '请选择举报类型',
		remark_placeholder: '请在此描述您的具体问题',
		select_report_type: '请选择举报类型',
		remark_max_length: '问题描述可以在500字以内',
		validate_all: '请检查必填字段',
		reportList: {
			Spam_and_Abuse: '垃圾信息和滥用行为',
			Pornographic: '色情和不雅内容',
			False_Information: '虚假信息',
			Intellectual: '知识产权侵权',
			Personal_safety: '人身安全和威胁',
			Hate_Speech: '仇恨言论',
			suicide_content: '自残或自杀内容',
			Account_theft: '盗号或欺诈',
			Impersonating_someone_else: '冒充他人身份',
			Harassment_Report: '骚扰举报',
			Invasion_of_Privacy: '侵犯隐私',
			Malware_or_links: '恶意软件或链接',
			Other: '其他'
		}
	},
	EditPersonalInformation: {
		page_title: '编辑个人信息',
		placeholder: {
			nickname: '请输入昵称',
			country: '请选择国家/地区',
			gender: '请选择性别',
			year: '选择年份',
			month: '选择月份',
			date: '选择日期'
		},
		genderList: {
			male: '男',
			female: '女',
			other: '其他'
		},
		rules: {
			nickname_required: '请输入昵称',
			nickname_length: '昵称必须在1到50个字符之间',
			avatar_required: '请上传个人头像',
			bg_img_required: '请上传主页背景图'
		}
	},
	ConfirmPrompt: {
		delete_tips: '你确定要删除吗？',
		Your_login: '您的登录已过期，请重新登录',
		experience_more: '登录以体验更多有趣的内容',
		Login_Tips: '登录提示'
	},
	SwiperArr: {
		Live: '直播'
	},
	tipsArr: {
		Send_successfully: '发送成功',
		Feedback_success: '反馈成功',
		Edited_success: '编辑成功',
		Disliked_user: '不喜欢的用户ID不能为空',
		System_Error: '系统错误',
		reported_post: '您已举报过此帖子',
		user_info_required_fields: '请检查并填写必填字段',
		network_request: '网络请求不存在',
	},
	buttonArr: {
		Submit: '提交',
		Follow: '关注',
		Unfollow: '取消关注',
		Edit: '编辑',
		Cancel: '取消',
		Confirm: '确认',
		Send: '发送',
		Save: '保存',
	},
	noDataArr: {
		interesting_things: '请登录以体验更多有趣的内容',
		No_data_yet: '暂无数据',
		follow_list: '您还没有关注任何人',
		fan_home_page: '发布有趣的内容以吸引更多人关注你',
		message: '暂无消息数据',
		comment_module: '暂无评论数据',
		likes_module: '暂无点赞数据',
		comment_replies_list: '暂无评论回复信息',
		new_fan_follow_list: '暂无新粉丝数据',
		search_user: '暂无相关推荐',
		go_login: '去登录'
	},
	timeArr: {
		Just_now: '刚刚',
		minute_ago: '分钟前',
		hour_ago: '小时前',
		Yesterday: '昨天',
		days_ago: '天前'
	},
	FileUploadArr: {
		image_formats: '上传的图片文件格式仅支持',
		image_size: '上传的图片大小不能超过',
		image_max_text: '最多只能上传',
		image_files: '个图片文件',
		video_formats: '上传的视频文件格式仅支持',
		video_size: '上传的视频文件大小不能超过',
		video_max_text: '最多只能上传',
		video_files: '个视频文件',
		avatar_image_formats: '上传的头像图片文件格式仅支持',
		avatar_image_size: '上传的头像图片文件最大为',
		avatar_max_text: '最多只能上传',
		avatar_files: '个头像图片文件',
		background_image_formats: '上传的背景图片文件格式仅支持',
		background_image_size: '上传的背景图片文件最大为',
		background_max_text: '最多只能上传',
		background_files: '个背景图片文件'
	},
	loading: '加载中',

	...zhLocale
}

export default zh
